/* Quick buy — collects name/phone/city/address/payment and creates the order
   through the Skinoria app. Shipping mirrors the Shopify delivery profile;
   the server recalculates both price and shipping, so this is display only. */
(function () {
  'use strict';

  var openBtn = document.getElementById('sk-qb-open');
  var modal = document.getElementById('sk-qb');
  if (!openBtn || !modal) return;

  var api = (modal.dataset.api || '').replace(/\/+$/, '');
  var form = document.getElementById('sk-qb-form');
  var errEl = document.getElementById('sk-qb-error');
  var submitBtn = document.getElementById('sk-qb-submit');
  var qtyEl = document.getElementById('sk-qb-qty');
  var doneEl = document.getElementById('sk-qb-done');

  var unitPrice = parseFloat(String(openBtn.dataset.price).replace(/,/g, '')) || 0;
  var lastFocus = null;

  var CAIRO = ['cairo', 'giza', 'october', 'helwan', 'القاهرة', 'الجيزة', 'حلوان', 'اكتوبر', 'أكتوبر'];
  var RESORT = ['hurghada', 'sharm', 'red sea', 'south sinai', 'الغردقة', 'شرم', 'البحر الاحمر', 'جنوب سيناء'];

  function shippingFor(city) {
    var c = String(city || '').trim().toLowerCase();
    if (!c) return null;
    if (CAIRO.some(function (x) { return c.indexOf(x) !== -1; })) return 85;
    if (RESORT.some(function (x) { return c.indexOf(x) !== -1; })) return 140;
    return 100;
  }

  function money(n) {
    return Number(n).toLocaleString('en-US', {
      minimumFractionDigits: 2, maximumFractionDigits: 2
    }) + 'EGP';
  }

  function qty() {
    return Math.min(Math.max(parseInt(qtyEl.value, 10) || 1, 1), 10);
  }

  function refreshTotals() {
    var sub = unitPrice * qty();
    var ship = shippingFor(document.getElementById('sk-qb-city').value);
    document.getElementById('sk-qb-sub').textContent = money(sub);
    document.getElementById('sk-qb-ship').textContent = ship == null ? '—' : money(ship);
    document.getElementById('sk-qb-total').textContent = money(sub + (ship || 0));
  }

  function open() {
    lastFocus = document.activeElement;
    document.getElementById('sk-qb-img').src = openBtn.dataset.image || '';
    document.getElementById('sk-qb-name').textContent = openBtn.dataset.title || '';
    document.getElementById('sk-qb-price').textContent = money(unitPrice);
    refreshTotals();
    modal.hidden = false;
    document.body.style.overflow = 'hidden';
    setTimeout(function () { document.getElementById('sk-qb-fullname').focus(); }, 60);
  }

  function close() {
    modal.hidden = true;
    document.body.style.overflow = '';
    if (lastFocus) lastFocus.focus();
  }

  openBtn.addEventListener('click', open);
  modal.querySelectorAll('[data-close]').forEach(function (el) {
    el.addEventListener('click', close);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !modal.hidden) close();
  });

  modal.querySelectorAll('.sk-qb__qty button').forEach(function (b) {
    b.addEventListener('click', function () {
      qtyEl.value = Math.min(Math.max(qty() + parseInt(b.dataset.step, 10), 1), 10);
      refreshTotals();
    });
  });
  qtyEl.addEventListener('input', refreshTotals);
  document.getElementById('sk-qb-city').addEventListener('input', refreshTotals);

  // ---- payment method: reveal the matching instructions ----
  var receiptBox = document.getElementById('sk-qb-receipt');
  var fileInput = document.getElementById('sk-qb-file');
  var previewBox = document.getElementById('sk-qb-preview');
  var thumb = document.getElementById('sk-qb-thumb');
  var receiptData = null;   // downscaled JPEG data URL

  function chosenMethod() {
    var el = form.querySelector('input[name="payment_method"]:checked');
    return el ? el.value : 'cod';
  }

  function syncPayment() {
    var m = chosenMethod();
    modal.querySelectorAll('.sk-qb__detail').forEach(function (d) {
      d.hidden = d.dataset.for !== m;
    });
    var manual = m === 'vodafone_cash' || m === 'instapay';
    receiptBox.hidden = !manual;
    if (!manual) clearReceipt();
  }

  form.querySelectorAll('input[name="payment_method"]').forEach(function (r) {
    r.addEventListener('change', syncPayment);
  });
  syncPayment();

  modal.querySelectorAll('.sk-qb__copy').forEach(function (b) {
    b.addEventListener('click', function () {
      var done = function () {
        b.textContent = 'Copied';
        setTimeout(function () { b.textContent = 'Copy'; }, 1800);
      };
      if (navigator.clipboard) navigator.clipboard.writeText(b.dataset.copy).then(done, done);
      else done();
    });
  });

  function clearReceipt() {
    receiptData = null;
    if (fileInput) fileInput.value = '';
    if (previewBox) previewBox.hidden = true;
  }

  // Downscale before upload — phone screenshots are several MB and we only
  // need it legible enough to read a transfer confirmation.
  function shrink(file) {
    return new Promise(function (resolve, reject) {
      var reader = new FileReader();
      reader.onerror = reject;
      reader.onload = function () {
        var img = new Image();
        img.onerror = reject;
        img.onload = function () {
          var max = 1400;
          var scale = Math.min(1, max / Math.max(img.width, img.height));
          var c = document.createElement('canvas');
          c.width = Math.round(img.width * scale);
          c.height = Math.round(img.height * scale);
          c.getContext('2d').drawImage(img, 0, 0, c.width, c.height);
          resolve(c.toDataURL('image/jpeg', 0.82));
        };
        img.src = reader.result;
      };
      reader.readAsDataURL(file);
    });
  }

  if (fileInput) {
    fileInput.addEventListener('change', function () {
      var f = fileInput.files && fileInput.files[0];
      if (!f) return clearReceipt();
      if (!/^image\//.test(f.type)) { clearReceipt(); return fail('Please choose an image file.'); }
      if (f.size > 15 * 1024 * 1024) { clearReceipt(); return fail('That image is too large (max 15MB).'); }
      shrink(f).then(function (dataUrl) {
        receiptData = dataUrl;
        thumb.src = dataUrl;
        previewBox.hidden = false;
        errEl.hidden = true;
      }).catch(function () { clearReceipt(); fail('We could not read that image.'); });
    });
  }
  var removeBtn = document.getElementById('sk-qb-remove');
  if (removeBtn) removeBtn.addEventListener('click', clearReceipt);

  // Meta match quality: _fbp identifies the browser, _fbc carries the ad click.
  // Both are set by the pixel that already runs on the storefront. When someone
  // lands straight from an ad the cookie may not exist yet, so fall back to
  // building _fbc from the fbclid in the URL exactly the way Meta specifies.
  function cookie(name) {
    var m = document.cookie.match(new RegExp('(^|;\\s*)' + name + '=([^;]*)'));
    return m ? decodeURIComponent(m[2]) : '';
  }

  function fbc() {
    var existing = cookie('_fbc');
    if (existing) return existing;
    var clid = new URLSearchParams(location.search).get('fbclid');
    return clid ? 'fb.1.' + Date.now() + '.' + clid : '';
  }

  function fail(msg) {
    errEl.textContent = msg;
    errEl.hidden = false;
    submitBtn.disabled = false;
    submitBtn.textContent = 'Confirm order';
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    errEl.hidden = true;

    var payload = {
      full_name: document.getElementById('sk-qb-fullname').value.trim(),
      phone: document.getElementById('sk-qb-phone').value.trim(),
      city: document.getElementById('sk-qb-city').value.trim(),
      address: document.getElementById('sk-qb-address').value.trim(),
      payment_method: chosenMethod(),
      variant_id: openBtn.dataset.variant,
      quantity: qty(),
      receipt: receiptData || undefined,
      fbp: cookie('_fbp'),
      fbc: fbc()
    };

    if (payload.full_name.length < 2) return fail('Please enter your full name.');
    if (payload.phone.replace(/\D/g, '').length < 10) return fail('Please enter a valid Egyptian mobile number.');
    if (!payload.city) return fail('Please enter your city.');
    if (payload.address.length < 6) return fail('Please enter your full address.');

    submitBtn.disabled = true;
    submitBtn.textContent = 'Placing order…';

    fetch(api + '/api/quick-order', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        if (!res.ok || !res.d.ok) return fail(res.d.error || 'Something went wrong. Please try again.');

        // The order exists now, so never leave the customer on the form.
        // Send them to the thank-you page; the inline panel below is only a
        // fallback for the case where that page is missing from the theme.
        form.hidden = true;
        document.querySelector('.sk-qb__item').hidden = true;
        doneEl.hidden = false;
        document.getElementById('sk-qb-done-text').textContent =
          'Your order ' + res.d.order + ' for ' + money(res.d.total) +
          ' is confirmed. We will call you shortly to arrange delivery.';

        // The thank-you page fires the Meta Purchase event, but the numbers it
        // shows come from the query string and anyone can edit those. Park the
        // server's own figures here instead so the revenue we report is the
        // revenue Shopify charged. Cleared as soon as it is used, which also
        // stops a page refresh reporting the same order twice.
        try {
          if (res.d.tracking) {
            sessionStorage.setItem('sk_purchase', JSON.stringify(res.d.tracking));
          }
        } catch (e) {
          /* private mode — the server-side event still reports this order */
        }

        try {
          var url = '/pages/thank-you?order=' + encodeURIComponent(res.d.order) +
                    '&total=' + encodeURIComponent(res.d.total) +
                    '&pay=' + encodeURIComponent(payload.payment_method || '');
          window.location.assign(url);
        } catch (e) {
          /* stay on the inline confirmation */
        }
      })
      .catch(function () {
        fail('We could not reach the server. Please check your connection and try again.');
      });
  });
})();
